module.exports = __webpack_public_path__ + "img/user-icon.7cb931dd.svg";